import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { RFP_VIEW_REQUEST_PROPOSAL_REFUSE, RFP_VIEW_REQUEST_PROPOSAL_TO_DO, RFP_VIEW_REQUEST_STATUS_DISAPPROVED, } from '../../../../../../define/consts/rfp';
import { INTERVIEW_STATUS_DECLINE, INTERVIEW_STATUS_DEFINITION, } from '../../../../../../define/consts/rfp/rfp_interview_define';
import { arraySortFuncMultiKeys } from '../../../../../../helpers/common/ArrayHelper';
import { propArrayShape, propBool, propChildren, } from '../../../../../../helpers/custom-prop-types';
import ViewRequestItem from './ViewRequestItem';
const ViewRequestTable = (props) => {
    const { emptyRow, isSort, viewRequests: rawViewRequests } = props;
    const viewRequests = useMemo(() => {
        const items = rawViewRequests.map((rawViewRequest) => ({
            item: rawViewRequest,
            view: Object.assign(Object.assign({}, (() => {
                const { offer, proposal, status } = rawViewRequest;
                const { interview_status: interviewStatus } = offer || {};
                if (interviewStatus === INTERVIEW_STATUS_DEFINITION.value) {
                    return {
                        className: 'interview_order',
                        label: '発注',
                        seq: 1,
                    };
                }
                if (status === RFP_VIEW_REQUEST_STATUS_DISAPPROVED.value) {
                    return {
                        className: 'status_disapproved',
                        label: '閲覧拒否',
                        seq: 7,
                    };
                }
                if (interviewStatus === INTERVIEW_STATUS_DECLINE.value) {
                    return {
                        className: 'interview_decline',
                        label: '見送り',
                        seq: 5,
                    };
                }
                if (offer) {
                    return {
                        className: 'offered',
                        label: '提案',
                        seq: 2,
                    };
                }
                if (proposal === RFP_VIEW_REQUEST_PROPOSAL_REFUSE.value) {
                    return {
                        className: 'proposal_refuse',
                        label: '提案辞退',
                        seq: 6,
                    };
                }
                if (proposal === RFP_VIEW_REQUEST_PROPOSAL_TO_DO.value) {
                    return {
                        className: 'proposal_to_do',
                        label: '提案予定',
                        seq: 3,
                    };
                }
                return {
                    className: 'proposal_doing',
                    label: '提案検討中',
                    seq: 4,
                };
            })()), { id: rawViewRequest.id }),
        }));
        if (isSort) {
            return items.sort((leftValue, rightValue) => arraySortFuncMultiKeys(leftValue.view, rightValue.view, ['seq', 'id']));
        }
        return items;
    }, [rawViewRequests, isSort]);
    return (_jsxs("table", Object.assign({ className: 'view_request_item_table' }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ className: 'head_company_name' }, { children: "\u4F01\u696D\u540D" })), _jsx("th", Object.assign({ className: 'head_professional_name' }, { children: "\u30B3\u30F3\u30B5\u30EB\u30BF\u30F3\u30C8\u540D" })), _jsx("th", Object.assign({ className: 'head_status' }, { children: "\u30B9\u30C6\u30FC\u30BF\u30B9" }))] }) }), _jsx("tbody", { children: viewRequests.length === 0
                    ? emptyRow
                    : viewRequests.map((viewRequest) => (_jsx(ViewRequestItem, { view: viewRequest.view, viewRequest: viewRequest.item }, viewRequest.item.id))) })] })));
};
ViewRequestTable.propTypes = {
    emptyRow: propChildren(),
    isSort: propBool(),
    viewRequests: propArrayShape().isRequired,
};
ViewRequestTable.defaultProps = {
    emptyRow: undefined,
    isSort: true,
};
export default ViewRequestTable;
